import {Avatar} from 'shells/avatar/avatar';
import {IconAndLabel} from 'shells/select-two-line-icon/icon-and-label';
import {getInitials} from 'shells/utils/get-initials';

import type {GetEmailSyncPotentialContacts_getEmailSyncPotentialContacts as EmailSyncFoundContact} from 'nutshell-graphql-types';

type Props = {
    contact: EmailSyncFoundContact;
};

export function EmailSyncRecentContactCell(props: Props) {
    return (
        <IconAndLabel
            iconNode={
                <Avatar
                    avatarUrl={null}
                    initials={getInitials(props.contact.emailAddress?.display ?? '')}
                    size={32}
                    circular={true}
                    type='contacts'
                />
            }
            label={props.contact.emailAddress?.display ?? ''}
            sublabel={props.contact.emailAddress?.address ?? ''}
        />
    );
}
